<template>
  <div class="mx-auto w-10/12 text-gray-800 dark:text-white">
    <div class="content flex w-full gap-4">
      <!-- 播放器 -->
      <div class="relative aspect-video flex-1" ref="playerContainer">
        <TCPlayer
          ref="playerRef"
          :licenseUrl="config.tcplayer.licenseUrl"
          :controls="false"
          :autoplay="true"
          :showHeader="false"
          :showLoadingAnimation="false"
          :src="currentVideoSrc"
          :showUnmuteButton="true"
          :showEnterButton="true"
          livePageUrl="/live"
          liveId="1"
          navigateOnHeader
          :isFloating="false"
        />
      </div>
      <!-- 缩略图列表 -->
      <div
        class="flex w-[240px] shrink-0 flex-col gap-2"
        :style="{ height: playerHeight + 'px' }"
      >
        <div
          v-for="(thumb, index) in thumbnails"
          :key="index"
          class="relative min-h-0 flex-1 cursor-pointer transition-opacity hover:opacity-80"
          :class="{ 'ring-2 ring-blue-500': index === activeThumbIndex }"
          @click="handleThumbClick(index, thumb)"
        >
          <el-image
            :src="thumb.image"
            :alt="thumb.title"
            class="h-full w-full rounded object-cover"
          />
          <div
            class="absolute right-0 bottom-0 left-0 rounded-b bg-linear-to-t from-black/60 to-transparent p-2"
          >
            <p class="truncate text-xs text-white">{{ thumb.title }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="relative mt-8 w-full space-y-8">
      <!-- 比赛列表 -->
      <MatchList :matches="matches" @match-select="handleMatchSelect" />

      <!-- 热门直播列表 -->
      <LiveCardGrid
        :lives="hotLives"
        navigateOnClick
        targetRoute="/live"
        @live-select="handleLiveSelect"
      />
    </div>
  </div>
</template>

<script setup>
const config = useProjectConfig();
definePageMeta({
  layout: "custom",
});
// 缩略图数据
const activeThumbIndex = ref(0);
// 示例直播源（用户提供）
const exampleSrc =
  "https://sf1-cdn-tos.huoshanstatic.com/obj/media-fe/xgplayer_doc_video/hls/xgplayer-demo.m3u8";
const currentVideoSrc = ref(exampleSrc);
const thumbnails = computed(() => {
  const list = hotLivesItems?.value || [];
  if (!list.length) {
    return [
      {
        image:
          "https://lqcos.beijxs.com/2025-03-31/1dba93241c6b2bf0f0b6651f6c8f9979.png",
        title: "直播标题 1",
        src: exampleSrc,
      },
      {
        image:
          "https://lqcos.beijxs.com/2025-01-10/e1465aebee437e1b0eb208ef6b4e76dc.jpg",
        title: "直播标题 2",
        src: exampleSrc,
      },
      {
        image:
          "https://lqcos.beijxs.com/2025-11-14/2bcd66b4da81e7eb3823cdc717d0dde0.png",
        title: "直播标题 3",
        src: exampleSrc,
      },
      {
        image:
          "https://lqcos.beijxs.com/2025-11-12/15130c65fc0715ee77c5a9875b4488ad.jpg",
        title: "直播标题 4",
        src: exampleSrc,
      },
    ];
  }
  return list.map((item) => ({
    image: item.thumbnail || "/indexbg.png",
    title: item.title,
    src: item.streamUrl || exampleSrc,
  }));
});

// 播放器引用
const playerRef = ref(null);

// 播放器容器引用和高度
const playerContainer = ref(null);
const playerHeight = ref(0);
let resizeObserver = null;

const updatePlayerHeight = () => {
  if (playerContainer.value) {
    playerHeight.value = playerContainer.value.offsetHeight;
  }
};

onMounted(async () => {
  await nextTick();
  updatePlayerHeight();

  // 使用 ResizeObserver 监听播放器容器高度变化
  if (playerContainer.value && typeof ResizeObserver !== "undefined") {
    resizeObserver = new ResizeObserver(() => {
      updatePlayerHeight();
    });
    resizeObserver.observe(playerContainer.value);
  }

  // 同时监听窗口大小变化
  window.addEventListener("resize", updatePlayerHeight);
});

onUnmounted(() => {
  if (resizeObserver && playerContainer.value) {
    resizeObserver.unobserve(playerContainer.value);
    resizeObserver.disconnect();
  }
  window.removeEventListener("resize", updatePlayerHeight);
});

import { mockMatches, mockChannels } from "~/mock/mockData";
import { useLives } from "~/composables/useLives";

const matches = ref(mockMatches);
const { items: hotLivesItems, load: loadLives } = useLives();
const hotLives = computed(() => hotLivesItems);
const currentChannelId = ref("");
const channels = ref(mockChannels);

// 处理缩略图点击
const handleThumbClick = (index, thumb) => {
  activeThumbIndex.value = index;
  if (thumb.src && thumb.src !== currentVideoSrc.value) {
    currentVideoSrc.value = thumb.src;
    console.log("切换播放源:", thumb.src);
  }
};

// 事件处理
const handleMatchSelect = (match) => {
  console.log("选择比赛:", match);
  // 可以在这里处理比赛选择逻辑，比如切换播放器视频源
};

const handleLiveSelect = (live) => {
  console.log("选择直播:", live);
  // 可以在这里处理直播选择逻辑，比如切换播放器视频源
};

onMounted(async () => {
  await loadLives({ hot: true });
});

const handleChannelSelect = (channel) => {
  console.log("选择频道:", channel);
  currentChannelId.value = channel.id;
  // 可以在这里处理频道选择逻辑，比如切换播放器视频源
};
</script>

<style scoped></style>
